export default function checkUnitAvailable(unit) {
  const isAvailable = unit?.is_available || unit?.isAvailable
  const availableState = isAvailable || 0

  let publicationState = unit?.publication_state || unit?.publicationState
  publicationState = publicationState || 'published'

  return availableState === 1 && publicationState === 'published'
}
